export function useCsp() {
	const name = 'x-csp-nonce'
	const token = useCookie<string>(name)
	return { cspNonce: token.value || undefined }
}
